import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class PromptClass {
    constructor(
        id = '',
        accountId = '',
        accounts = [],
        eventId = '',
        message = '',
        moduleId = '',
        name = '',
        order = 1,
        register = new Date()?.toISOString(),
        status = false,
        getContext = false,
    ) {
        this.id = id;
        this.accountId = accountId;
        this.accounts = accounts;
        this.eventId = eventId;
        this.message = message;
        this.moduleId = moduleId;
        this.name = name;
        this.order = order;
        this.register = register;
        this.status = status;
        this.getContext = getContext;
    }

    static getClassName = () => {
        return 'Prompt - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName(), })?.result) {
            return new PromptClass(
                obj?.id,
                obj?.accountId,
                obj?.accounts,
                obj?.eventId,
                obj?.message,
                obj?.moduleId,
                obj?.name,
                obj?.order,
                obj?.register,
                obj?.status,
                obj?.getContext
            );
        } else {
            return new PromptClass();
        }
    }
}